var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c;
import React, { useCallback, useEffect, useMemo, useState } from "react";
import client from "../../http/client";
import { bugsnagClient } from "../../themes/streamlined/streamlined";
import { MenuItemCard } from "../menuItemCard";
import { ItemCustomizationDialog } from "../itemCustomization";
import { RadixButton } from "../primitives/RadixButton";
import { DeleteIcon, EditIconCheckbox } from "../icons";
import { parseSpecialFlowResponse, parseSpecialSubmitPayload, parseSpecialValidationError, } from "./specialsApi";
import "./specials.css";
import { formatter } from "../utility/formatter";
import { shouldDisplayMenuEntity } from "../utility/menuItemVisibility";
var PENDING_TOAST_STORAGE_KEY = "ui-pending-toast";
var SPECIAL_ITEM_PAYLOAD_STORAGE_KEY = "ui-special-item-payloads";
var SPECIAL_NAME = (_c = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store_branding) === null || _b === void 0 ? void 0 : _b.special_name) !== null && _c !== void 0 ? _c : "deal";
var getRelativeUri = function () {
    var _a, _b;
    var appWindow = window;
    if (typeof appWindow.relativeURI === "function") {
        return appWindow.relativeURI();
    }
    var storeSlug = (_b = (_a = appWindow.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.urlslug;
    return storeSlug ? "/".concat(storeSlug) : "";
};
var getCurrentSpecialId = function () {
    var pathSegments = window.location.pathname.split("/").filter(function (segment) { return segment.length > 0; });
    var specialId = pathSegments[pathSegments.length - 1];
    return specialId || null;
};
var clearSpecialEditState = function () {
    var appWindow = window;
    delete appWindow.editLineID;
    delete appWindow.editLineQty;
    delete appWindow.editItemChoices;
    delete appWindow.editLineComment;
};
var getOrderedPages = function (special) {
    var pagesById = special.pages || {};
    var orderedPages = [];
    var visitedPageIds = {};
    var nextPageId = special.first_page;
    while (nextPageId && pagesById[String(nextPageId)] && !visitedPageIds[String(nextPageId)]) {
        var page = pagesById[String(nextPageId)];
        orderedPages.push(page);
        visitedPageIds[String(page.id)] = true;
        nextPageId = page.next_page;
    }
    Object.keys(pagesById)
        .map(function (pageId) { return pagesById[pageId]; })
        .filter(function (page) { return !visitedPageIds[String(page.id)]; })
        .sort(function (firstPage, secondPage) { return firstPage.id - secondPage.id; })
        .forEach(function (page) { return orderedPages.push(page); });
    return orderedPages;
};
var getPageSelectedCount = function (choices) {
    return choices.reduce(function (total, choice) { return total + Number(choice.quantity || 0); }, 0);
};
var pageMeetsRequirements = function (page, choices) {
    var selectedCount = getPageSelectedCount(choices);
    var meetsMinimum = selectedCount >= page.minimum_required;
    var meetsMaximum = page.maximum_allowed === 0 || selectedCount <= page.maximum_allowed;
    return meetsMinimum && meetsMaximum;
};
var findFirstInvalidPage = function (pages, choicesByPage) {
    for (var index = 0; index < pages.length; index += 1) {
        var page = pages[index];
        var pageChoices = choicesByPage[String(page.id)] || [];
        if (!pageMeetsRequirements(page, pageChoices)) {
            return page;
        }
    }
    return null;
};
var findItemNavigationById = function (itemNavigations, itemNavigationId) {
    for (var index = 0; index < itemNavigations.length; index += 1) {
        if (itemNavigations[index].id === itemNavigationId) {
            return itemNavigations[index];
        }
    }
    return null;
};
var getCategoryDebugData = function (itemNavigation) {
    return itemNavigation.categories.map(function (category) { return ({
        id: category.id,
        name: category.name,
    }); });
};
var buildCustomizationDebugContext = function (special, page, itemNavigation, itemUrl, selectedIndex) {
    var _a, _b;
    var primaryCategory = itemNavigation.categories[0] || null;
    return {
        specialId: special.id,
        specialName: special.name,
        specialFirstPage: special.first_page,
        pageId: page.id,
        pageName: page.name,
        selectedIndex: selectedIndex,
        itemNavigationId: itemNavigation.id,
        itemNavigationName: itemNavigation.name,
        itemNavigationMenuId: itemNavigation.menu_id,
        itemNavigationItemGroupId: itemNavigation.item_group_id,
        itemNavigationSnapshot: itemNavigation,
        primaryCategoryId: (_a = primaryCategory === null || primaryCategory === void 0 ? void 0 : primaryCategory.id) !== null && _a !== void 0 ? _a : null,
        primaryCategoryName: (_b = primaryCategory === null || primaryCategory === void 0 ? void 0 : primaryCategory.name) !== null && _b !== void 0 ? _b : null,
        allCategoryReferences: getCategoryDebugData(itemNavigation),
        generatedItemUrl: itemUrl,
        generatedItemApiUrl: itemUrl ? "".concat(itemUrl, "/api") : null,
        expectedRoutePattern: "".concat(getRelativeUri(), "/menu/categories/{category_id}/items/{item_id}/api"),
        currentPath: window.location.pathname,
        currentHref: window.location.href,
        relativeUri: getRelativeUri(),
    };
};
var getItemPayload = function (itemNavigation) {
    var category = itemNavigation.categories[0];
    if (!category) {
        return null;
    }
    return {
        item: itemNavigation,
        category: category,
    };
};
var getItemCustomizationUrl = function (itemNavigation) {
    var _a;
    var categoryId = (_a = itemNavigation.categories[0]) === null || _a === void 0 ? void 0 : _a.id;
    if (!categoryId) {
        return null;
    }
    return "".concat(getRelativeUri(), "/menu/categories/").concat(encodeURIComponent(String(categoryId)), "/items/").concat(encodeURIComponent(String(itemNavigation.id)));
};
var buildSelectedChoice = function (itemContext) {
    var _a, _b;
    var choices = __assign(__assign({}, (itemContext.choices || {})), { category: itemContext.categoryName });
    var selectedItemIndex = Number(choices.item || 0);
    var selectedItem = (_b = (_a = itemContext.itemGroup) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[selectedItemIndex];
    if (!(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) || !itemContext.itemNavigationID) {
        return null;
    }
    var modifiers = [];
    var includedModifiers = choices.includedModifiers || {};
    Object.keys(includedModifiers).forEach(function (modifierId) {
        var modifierChoice = includedModifiers[modifierId];
        modifiers.push({
            id: Number(modifierId),
            quantity: Number(modifierChoice.quantity || 0),
            portion: modifierChoice.portion,
            size: modifierChoice.size,
        });
    });
    var optionalModifiers = choices.modifiers || {};
    Object.keys(optionalModifiers).forEach(function (modifierId) {
        if (modifierId === "0") {
            return;
        }
        var modifierChoice = optionalModifiers[modifierId];
        var modifierQuantity = Number(modifierChoice.quantity || 0);
        if (modifierQuantity <= 0) {
            return;
        }
        modifiers.push({
            id: Number(modifierId),
            quantity: modifierQuantity,
            portion: modifierChoice.portion,
            size: modifierChoice.size,
        });
    });
    var addOns = [];
    var selectedAddOns = choices.addOns || {};
    Object.keys(selectedAddOns).forEach(function (addOnId) {
        var addOnChoice = selectedAddOns[addOnId];
        var addOnQuantity = Number(addOnChoice.quantity || 0);
        if (addOnQuantity <= 0) {
            return;
        }
        addOns.push({
            id: Number(addOnId),
            quantity: addOnQuantity,
        });
    });
    return {
        item: Number(selectedItem.id),
        quantity: Number(itemContext.quantity || 1),
        modifiers: modifiers,
        addOns: addOns,
        name: String(itemContext.name || "Selected item"),
        itemNavigation: Number(itemContext.itemNavigationID),
        choices: choices,
        comment: String(itemContext.comment || ""),
    };
};
var cacheSpecialItemPayloads = function (pages, choicesByPage) {
    var payloadsByItemNavigation = {};
    pages.forEach(function (page) {
        var pageChoices = choicesByPage[String(page.id)] || [];
        pageChoices.forEach(function (choice) {
            var itemNavigation = findItemNavigationById(page.item_navs, choice.itemNavigation);
            if (!itemNavigation) {
                return;
            }
            var itemPayload = getItemPayload(itemNavigation);
            if (itemPayload) {
                payloadsByItemNavigation[String(itemNavigation.id)] = itemPayload;
            }
        });
    });
    try {
        window.sessionStorage.setItem(SPECIAL_ITEM_PAYLOAD_STORAGE_KEY, JSON.stringify(payloadsByItemNavigation));
    }
    catch (error) {
        var debugContext = {
            itemNavigationIds: Object.keys(payloadsByItemNavigation),
            errorMessage: error instanceof Error ? error.message : String(error),
        };
        // eslint-disable-next-line no-console
        console.warn("[SpecialFlowPage] Unable to cache special item payloads.", debugContext);
        bugsnagClient.leaveBreadcrumb("Unable to cache special item payloads.", debugContext);
    }
};
var storePendingToast = function (message) {
    window.sessionStorage.setItem(PENDING_TOAST_STORAGE_KEY, JSON.stringify({
        message: message,
        variant: "success",
    }));
};
export var SpecialFlowPage = function () {
    var _a, _b, _c, _d, _e;
    var _f = useState(null), special = _f[0], setSpecial = _f[1];
    var _g = useState({}), selectedChoicesByPage = _g[0], setSelectedChoicesByPage = _g[1];
    var _h = useState(null), activeCustomization = _h[0], setActiveCustomization = _h[1];
    var _j = useState(true), isLoading = _j[0], setIsLoading = _j[1];
    var _k = useState(false), isSubmitting = _k[0], setIsSubmitting = _k[1];
    var _l = useState(null), errorMessage = _l[0], setErrorMessage = _l[1];
    useEffect(function () {
        var isMounted = true;
        var specialId = getCurrentSpecialId();
        if (!specialId) {
            setErrorMessage("Unable to load this special.");
            setIsLoading(false);
            return function () {
                isMounted = false;
            };
        }
        client.get("/menu/specials/".concat(encodeURIComponent(specialId), "/api"))
            .then(function (response) {
            if (!isMounted) {
                return;
            }
            var parsedSpecial = parseSpecialFlowResponse(response.data);
            if (parsedSpecial.success === false) {
                setErrorMessage(parsedSpecial.error);
                setSpecial(null);
                setIsLoading(false);
                return;
            }
            setSpecial(parsedSpecial.data);
            setErrorMessage(null);
            setIsLoading(false);
        }, function () {
            if (!isMounted) {
                return;
            }
            setErrorMessage("Unable to load this special. Please refresh the page and try again.");
            setSpecial(null);
            setIsLoading(false);
        });
        return function () {
            isMounted = false;
        };
    }, []);
    useEffect(function () {
        return function () { return clearSpecialEditState(); };
    }, []);
    var orderedPages = useMemo(function () {
        return special ? getOrderedPages(special) : [];
    }, [special]);
    var invalidPage = useMemo(function () {
        return findFirstInvalidPage(orderedPages, selectedChoicesByPage);
    }, [orderedPages, selectedChoicesByPage]);
    var totalSelectedCount = useMemo(function () {
        return Object.keys(selectedChoicesByPage).reduce(function (total, pageId) { return total + getPageSelectedCount(selectedChoicesByPage[pageId]); }, 0);
    }, [selectedChoicesByPage, special]);
    var handleBackToMenu = useCallback(function () {
        window.location.href = "".concat(getRelativeUri(), "/menu");
    }, []);
    var openCustomization = useCallback(function (page, itemNavigation, selectedIndex) {
        var _a;
        if (selectedIndex === void 0) { selectedIndex = null; }
        if (!special) {
            setErrorMessage("Unable to customize this item because the special is still loading.");
            return;
        }
        var itemUrl = getItemCustomizationUrl(itemNavigation);
        var itemPayload = getItemPayload(itemNavigation);
        var debugContext = buildCustomizationDebugContext(special, page, itemNavigation, itemUrl, selectedIndex);
        // eslint-disable-next-line no-console
        console.info("[SpecialFlowPage] Opening item customization dialog", debugContext);
        bugsnagClient.leaveBreadcrumb("Special item customization target selected.", debugContext);
        if (!itemUrl || !itemPayload) {
            // eslint-disable-next-line no-console
            console.error("[SpecialFlowPage] Missing category for item customization target", debugContext);
            bugsnagClient.notify(new Error("Special item customization target missing category."), function (event) {
                event.addMetadata("specialItemCustomization", debugContext);
            });
            setErrorMessage("Unable to customize this item because its menu category is unavailable.");
            return;
        }
        clearSpecialEditState();
        if (selectedIndex !== null) {
            var selectedChoice = (_a = selectedChoicesByPage[String(page.id)]) === null || _a === void 0 ? void 0 : _a[selectedIndex];
            var appWindow = window;
            appWindow.editLineID = "special-".concat(page.id, "-").concat(selectedIndex);
            appWindow.editLineQty = (selectedChoice === null || selectedChoice === void 0 ? void 0 : selectedChoice.quantity) || 1;
            appWindow.editItemChoices = (selectedChoice === null || selectedChoice === void 0 ? void 0 : selectedChoice.choices) ? JSON.stringify(selectedChoice.choices) : "";
            appWindow.editLineComment = (selectedChoice === null || selectedChoice === void 0 ? void 0 : selectedChoice.comment) || "";
        }
        setActiveCustomization({
            pageId: String(page.id),
            itemNavigation: itemNavigation,
            itemUrl: itemUrl,
            selectedIndex: selectedIndex,
            debugContext: debugContext,
            itemPayload: itemPayload,
        });
        setErrorMessage(null);
    }, [selectedChoicesByPage, special]);
    var closeCustomization = useCallback(function (open) {
        if (open) {
            return;
        }
        setActiveCustomization(null);
        clearSpecialEditState();
    }, []);
    var handleCustomizationSubmit = useCallback(function (itemContext) {
        if (!activeCustomization || !special) {
            return ["requirements_unmet", null, null, "Unable to add this item to the special. Please try again."];
        }
        var selectedChoice = buildSelectedChoice(itemContext);
        if (!selectedChoice) {
            return ["requirements_unmet", null, null, "Unable to add this item to the special. Please review your selections."];
        }
        var page = special.pages[activeCustomization.pageId];
        var existingPageChoices = selectedChoicesByPage[activeCustomization.pageId] || [];
        var selectedCountWithoutEditedChoice = existingPageChoices.reduce(function (total, choice, index) {
            if (index === activeCustomization.selectedIndex) {
                return total;
            }
            return total + Number(choice.quantity || 0);
        }, 0);
        var nextSelectedCount = selectedCountWithoutEditedChoice + selectedChoice.quantity;
        if (page.maximum_allowed !== 0 && nextSelectedCount > page.maximum_allowed) {
            return [
                "requirements_unmet",
                null,
                null,
                "This section allows ".concat(page.maximum_allowed, " item").concat(page.maximum_allowed === 1 ? "" : "s", ". Adjust your quantity or remove another selection before adding this item."),
            ];
        }
        setSelectedChoicesByPage(function (currentChoices) {
            var _a;
            var pageChoices = __spreadArray([], (currentChoices[activeCustomization.pageId] || []), true);
            if (activeCustomization.selectedIndex !== null) {
                pageChoices[activeCustomization.selectedIndex] = selectedChoice;
            }
            else {
                pageChoices.push(selectedChoice);
            }
            return __assign(__assign({}, currentChoices), (_a = {}, _a[activeCustomization.pageId] = pageChoices, _a));
        });
        return undefined;
    }, [activeCustomization, selectedChoicesByPage, special]);
    var removeSelectedChoice = useCallback(function (pageId, selectedIndex) {
        setSelectedChoicesByPage(function (currentChoices) {
            var _a;
            var nextPageChoices = __spreadArray([], (currentChoices[pageId] || []), true);
            nextPageChoices.splice(selectedIndex, 1);
            return __assign(__assign({}, currentChoices), (_a = {}, _a[pageId] = nextPageChoices, _a));
        });
    }, []);
    var scrollToPage = function (pageId) {
        var sectionElement = document.getElementById("special-section-".concat(pageId));
        if (!sectionElement) {
            return;
        }
        sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    var buildSubmitPayload = function () {
        if (!special) {
            return null;
        }
        var pages = orderedPages.reduce(function (payloadPages, page) {
            payloadPages[String(page.id)] = selectedChoicesByPage[String(page.id)] || [];
            return payloadPages;
        }, {});
        return {
            special_id: special.id,
            pages: pages,
        };
    };
    var submitSpecial = function () { return __awaiter(void 0, void 0, Promise, function () {
        var payload, parsedPayload, error_1, responseData, validationError;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!special) {
                        return [2 /*return*/];
                    }
                    if (invalidPage) {
                        setErrorMessage("Please complete ".concat(invalidPage.name, " before adding this special."));
                        scrollToPage(invalidPage.id);
                        return [2 /*return*/];
                    }
                    payload = buildSubmitPayload();
                    parsedPayload = parseSpecialSubmitPayload(payload);
                    if (parsedPayload.success === false) {
                        setErrorMessage(parsedPayload.error);
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    setErrorMessage(null);
                    cacheSpecialItemPayloads(orderedPages, selectedChoicesByPage);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client.post("/cart/add_special/api", parsedPayload.data)];
                case 2:
                    _b.sent();
                    storePendingToast("".concat(special.name, " added to cart."));
                    window.location.href = "".concat(getRelativeUri(), "/menu");
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    responseData = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data;
                    validationError = parseSpecialValidationError(responseData);
                    setErrorMessage(validationError.message || validationError.description || "Unable to add this ".concat(SPECIAL_NAME, ". Please review your selections and try again."));
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (isLoading) {
        return (React.createElement("div", { className: "special-flow-page special-flow-page--loading" },
            React.createElement("div", { className: "special-flow-status-card" },
                "Loading ",
                SPECIAL_NAME,
                "...")));
    }
    if (!special) {
        return (React.createElement("div", { className: "special-flow-page special-flow-page--error" },
            React.createElement("div", { className: "special-flow-status-card" },
                React.createElement("h1", null, "Special unavailable"),
                React.createElement("p", null, errorMessage || "Unable to load this special."),
                React.createElement(RadixButton, { className: "special-flow-secondary-action", onClick: handleBackToMenu }, "Back to menu"))));
    }
    return (React.createElement("div", { className: "special-flow-page" },
        React.createElement("header", { className: "special-flow-hero" },
            React.createElement("div", { className: "special-flow-hero__content" },
                React.createElement("button", { type: "button", className: "special-flow-back-button", onClick: handleBackToMenu }, "Back to menu"),
                special.imageURL ? (React.createElement("img", { src: special.imageURL, alt: special.name, className: "special-flow-hero__image" })) : null,
                React.createElement("p", { className: "special-flow-eyebrow" },
                    "Build your ",
                    SPECIAL_NAME),
                React.createElement("h1", null, special.name),
                special.description ? React.createElement("p", { className: "special-flow-description" }, special.description) : null,
                React.createElement("div", { className: "special-flow-hero__meta" },
                    React.createElement("span", null,
                        orderedPages.length,
                        " section",
                        orderedPages.length === 1 ? "" : "s"),
                    React.createElement("span", null,
                        totalSelectedCount,
                        " selected")))),
        errorMessage ? React.createElement("div", { className: "special-flow-error", role: "alert" }, errorMessage) : null,
        React.createElement("main", { className: "special-flow-sections" }, orderedPages.map(function (page) {
            var pageId = String(page.id);
            var pageChoices = selectedChoicesByPage[pageId] || [];
            var selectedCount = getPageSelectedCount(pageChoices);
            var isComplete = pageMeetsRequirements(page, pageChoices);
            var hasReachedMaximum = page.maximum_allowed > 0 && selectedCount >= page.maximum_allowed;
            return (React.createElement("section", { className: "special-flow-section", id: "special-section-".concat(page.id), key: page.id },
                React.createElement("div", { className: "special-flow-section__header" },
                    React.createElement("div", null,
                        React.createElement("p", { className: "special-flow-section__step" }, page.name),
                        React.createElement("h2", null, "Choose your items")),
                    React.createElement("div", { className: isComplete ? "special-flow-section__status special-flow-section__status--complete" : "special-flow-section__status" },
                        selectedCount,
                        " / ",
                        page.minimum_required,
                        " required",
                        page.maximum_allowed ? React.createElement("span", null,
                            "Max ",
                            page.maximum_allowed) : React.createElement("span", null, "No max"))),
                pageChoices.length > 0 ? (React.createElement("div", { className: "special-flow-selected-items", "aria-label": "Selected items for ".concat(page.name) }, pageChoices.map(function (choice, choiceIndex) { return (React.createElement("div", { className: "special-flow-selected-item", key: "".concat(choice.itemNavigation, "-").concat(choiceIndex) },
                    React.createElement("div", null,
                        React.createElement("strong", null, choice.name),
                        React.createElement("span", null,
                            "Qty ",
                            choice.quantity)),
                    React.createElement("div", { className: "special-flow-selected-item__actions" },
                        React.createElement("button", { type: "button", className: "special-flow-selected-item-action-button", "aria-label": "Edit ".concat(choice.name), onClick: function () {
                                var itemNavigation = findItemNavigationById(page.item_navs, choice.itemNavigation);
                                if (itemNavigation) {
                                    openCustomization(page, itemNavigation, choiceIndex);
                                }
                            } },
                            React.createElement(EditIconCheckbox, null)),
                        React.createElement("button", { type: "button", className: "special-flow-selected-item-action-button", "aria-label": "Remove ".concat(choice.name), onClick: function () { return removeSelectedChoice(pageId, choiceIndex); } },
                            React.createElement(DeleteIcon, null))))); }))) : null,
                !hasReachedMaximum ? (React.createElement("div", { className: "special-flow-item-grid" }, page.item_navs.filter(function (itemNavigation) { return shouldDisplayMenuEntity(itemNavigation); }).map(function (itemNavigation) { return (React.createElement(MenuItemCard, { key: itemNavigation.id, imageUrl: itemNavigation.imageURL || itemNavigation.imageURL_banner || undefined, label: itemNavigation.name, levelPrice: itemNavigation.level_price, matrixWeight: itemNavigation.matrix_weight, itemGroup: itemNavigation.item_group, menu_id: itemNavigation.menu_id || itemNavigation.id, isCore: itemNavigation.is_core, onCallToAction: function () { return openCustomization(page, itemNavigation); }, className: "special-flow-menu-item-card" })); }))) : null));
        })),
        React.createElement("aside", { className: "special-flow-submit-bar", "aria-label": "Special summary" },
            React.createElement("div", null,
                React.createElement("strong", null, special.name),
                React.createElement("span", null, invalidPage ? "Next: complete ".concat(invalidPage.name) : "Ready to add to cart")),
            React.createElement(RadixButton, { className: "special-flow-submit-button", disabled: isSubmitting || Boolean(invalidPage), onClick: submitSpecial }, isSubmitting ? "Adding..." : formatter.toProperCase("Add ".concat(SPECIAL_NAME, " to cart")))),
        React.createElement(ItemCustomizationDialog, { key: activeCustomization ? "".concat(activeCustomization.pageId, "-").concat(activeCustomization.itemNavigation.id, "-").concat((_a = activeCustomization.selectedIndex) !== null && _a !== void 0 ? _a : "new") : "special-customization-empty", open: Boolean(activeCustomization), onOpenChange: closeCustomization, itemUrl: (activeCustomization === null || activeCustomization === void 0 ? void 0 : activeCustomization.itemUrl) || null, title: (activeCustomization === null || activeCustomization === void 0 ? void 0 : activeCustomization.itemNavigation.name) || "Customize item", editMode: activeCustomization !== null && activeCustomization.selectedIndex !== null, submitCustomizationAttempt: handleCustomizationSubmit, successMessage: activeCustomization !== null && activeCustomization.selectedIndex !== null ? "Item updated in special." : "Item added to special.", openSuggestiveSellOnAdd: false, debugContext: activeCustomization === null || activeCustomization === void 0 ? void 0 : activeCustomization.debugContext, initialChoices: activeCustomization && activeCustomization.selectedIndex !== null ? ((_c = (_b = selectedChoicesByPage[activeCustomization.pageId]) === null || _b === void 0 ? void 0 : _b[activeCustomization.selectedIndex]) === null || _c === void 0 ? void 0 : _c.choices) || null : null, initialItemPayload: (activeCustomization === null || activeCustomization === void 0 ? void 0 : activeCustomization.itemPayload) || null, initialQuantity: activeCustomization && activeCustomization.selectedIndex !== null ? ((_e = (_d = selectedChoicesByPage[activeCustomization.pageId]) === null || _d === void 0 ? void 0 : _d[activeCustomization.selectedIndex]) === null || _e === void 0 ? void 0 : _e.quantity) || null : null })));
};
